<template>
  <div class="message-subscription">
    <div class="tips">
      提示：选择订阅素材更新的分组，系统在每天00:00统计，将更新的素材消息在次日上午9：00通知到您。
    </div>
    <div class="grouping">
      <div class="grouping-list">
        <div
          v-for="item in flatList"
          :key="item.groupId"
          class="grouping-item"
          :class="item.parentId === 0 ? 'title' : ''"
          :style="{ paddingLeft: item.level * 20 + 'px' }"
          @click="changeMessage(item.groupId)"
        >
          <span>{{ item.groupName }}</span>
          <van-icon
            v-if="groupIdList.includes(item.groupId)"
            name="success"
            color="#0576c4"
          />
        </div>
      </div>
      <div class="btn-box">
        <div class="btn" @click="updateMessages">
          更新订阅消息
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSubscribeListApi,
  subscribeApi,
  currGroupListBy5LevelApi,
} from "@/api/modules/material";
import { Toast } from "vant";

export default {
  data() {
    return {
      messageList: [], // 消息订阅列表
      groupTree: [], // 原始树状结构，用于层级逻辑处理
      flatList: [], // 扁平结构列表，用于页面渲染
      groupIdList: [], // 消息订阅选择列表
    };
  },
  created() {
    this.getGroupList();
    this.getSubscribeList();
  },
  methods: {
    // 获取已订阅内容
    async getSubscribeList() {
      const res = await getSubscribeListApi();
      if (res.code === 0) {
        // 获取树状结构分组中的所有 id
        setTimeout(() => {
          const allGroupIds = this.getAllGroupIdsFromTree(this.groupTree);
          this.groupIdList = res.data.filter((id) => allGroupIds.includes(id));
        }, 500);
      }
    },
    // 从树状结构分组中获取所有的 id
    getAllGroupIdsFromTree(tree) {
      let allIds = [];
      tree.forEach((group) => {
        allIds.push(group.groupId);
        if (group.childPath && group.childPath.length > 0) {
          allIds = allIds.concat(this.getAllGroupIdsFromTree(group.childPath));
        }
      });
      return allIds;
    },
    // 获取树状结构分组
    async getGroupList() {
      const res = await currGroupListBy5LevelApi({
        parentId: 0,
      });
      if (res.code === 0) {
        // 存储原始树状结构
        this.groupTree = res.data;
        // 生成扁平结构列表
        this.flatList = [];
        this.convertTreeToFlat(this.groupTree, 0);
      }
    },
    // 将树状结构转换为扁平结构
    convertTreeToFlat(tree, level) {
      tree.forEach((group) => {
        // 复制分组信息并添加层级属性
        const flatGroup = {
          ...group,
          level: level,
          expanded: false,
        };
        this.flatList.push(flatGroup);
        // 递归处理子分组
        if (group.childPath && group.childPath.length > 0) {
          this.convertTreeToFlat(group.childPath, level + 1);
        }
      });
    },
    // 更新父分组状态
    updateParentGroupStatus(group) {
      if (!group || group.parentId === 0) return;
      const parentGroup = this.findGroupInTree(this.groupTree, group.parentId);
      if (!parentGroup) return;

      const allChildrenSelected = parentGroup.childPath.every((child) =>
        this.groupIdList.includes(child.groupId)
      );

      if (
        !allChildrenSelected &&
        this.groupIdList.includes(parentGroup.groupId)
      ) {
        this.groupIdList = this.groupIdList.filter(
          (id) => id !== parentGroup.groupId
        );
        // 递归更新上层父分组状态
        this.updateParentGroupStatus(parentGroup);
      }
    },
    // 在树状结构中查找分组
    findGroupInTree(tree, id) {
      for (const group of tree) {
        if (group.groupId === id) return group;
        if (group.childPath && group.childPath.length > 0) {
          const result = this.findGroupInTree(group.childPath, id);
          if (result) return result;
        }
      }
      return null;
    },
    // 获取分组及其所有子分组ID
    getChildIdsFromTree(group) {
      if (!group) return [];
      const ids = [group.groupId];
      if (group.childPath && group.childPath.length > 0) {
        group.childPath.forEach((child) => {
          ids.push(...this.getChildIdsFromTree(child));
        });
      }
      return ids;
    },
    // 检查父分组状态
    checkParentGroupInTree(group) {
      if (!group || group.parentId === 0) return;
      const parentGroup = this.findGroupInTree(this.groupTree, group.parentId);
      if (!parentGroup) return;

      const allChildrenSelected = parentGroup.childPath.every((child) =>
        this.groupIdList.includes(child.groupId)
      );

      if (
        allChildrenSelected &&
        !this.groupIdList.includes(parentGroup.groupId)
      ) {
        this.groupIdList = [...this.groupIdList, parentGroup.groupId];
        this.checkParentGroupInTree(parentGroup);
      } else if (
        !allChildrenSelected &&
        this.groupIdList.includes(parentGroup.groupId)
      ) {
        this.groupIdList = this.groupIdList.filter(
          (id) => id !== parentGroup.groupId
        );
      }
    },
    // 选择订阅信息
    changeMessage(groupId) {
      // 查找分组
      const group = this.findGroupInTree(this.groupTree, groupId);
      if (!group) return;

      // 处理选中/取消选中逻辑
      if (this.groupIdList.includes(groupId)) {
        const allChildIds = this.getChildIdsFromTree(group);
        this.groupIdList = this.groupIdList.filter(
          (id) => !allChildIds.includes(id)
        );
        // 取消选中时，更新所有父分组状态
        this.updateParentGroupStatus(group);
      } else {
        const allChildIds = this.getChildIdsFromTree(group);
        this.groupIdList = [...this.groupIdList, ...allChildIds];
        // 检查父分组状态
        this.checkParentGroupInTree(group);
      }
    },
    // 更新订阅信息
    async updateMessages() {
      const res = await subscribeApi({
        groupId: this.groupIdList,
      });
      if (res.code === 0) {
        Toast.success("提交成功");
        this.getSubscribeList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.message-subscription {
  width: 100%;
  height: 100%;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 50px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 50px);
  .tips {
    padding: 10px 15px;
    font-size: 12px;
    color: #999999;
  }
  .grouping {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
    padding-bottom: 15px;
    .grouping-list {
      padding: 0 15px;
      margin-bottom: 20px;
      overflow-y: auto;
    }
    .grouping-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      font-size: 15px;
      color: #333333;
      border-bottom: 1px solid #f3f3f3;
    }
    .title {
      font-weight: 500;
    }
    .btn-box {
      width: 100%;
      padding: 0 15px;
      .btn {
        width: 100%;
        height: 42px;
        background: #f26147;
        border-radius: 8px 8px 8px 8px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 42px;
        cursor: pointer;
      }
    }
  }
}
</style>
